import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectIsTraderEventRunning, selectTraderEventRemainingTime, } from "../../../selectors/selectTraderEventInfo";
import { utilButton } from "../../../utils/utilButton";
import { utilTime } from "../../../utils/utilTime";
import { TimerCountdown } from "../../generic/timer/TimerCountdown";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
var _HudButtonTraderEvent = function (_a) {
    var onClick = _a.onClick, traderEventRemainingTime = _a.traderEventRemainingTime, shouldRender = _a.shouldRender;
    if (utilTime.secondsLeftTill(traderEventRemainingTime) <= 0 || !shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: IdStyles.TraderBadge + "  hud-button__offers hud-button__trader-event", onClick: function () { return utilButton.onClickWithSound(onClick); } },
        React.createElement(TimerCountdown, { remainingTime: traderEventRemainingTime, className: IdStyles.TextBoldPrimary + " hud-button__purchase-points-event-text" })));
};
var mapState = function (state) { return ({
    shouldRender: selectIsTraderEventRunning(state),
    traderEventRemainingTime: selectTraderEventRemainingTime(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionModalOpen(IdModal.TraderEvent)); },
}); };
export var HudButtonTraderEvent = connect(mapState, mapDispatch)(_HudButtonTraderEvent);



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/components/HudButtonTraderEvent.tsx
// module id = 2296
// module chunks = 3